<app-popup
  [isOpen]="isOpen()"
  [size]="activeTab() === 'upload' ? 'xxlarge' : 'large'"
  color="mint"
  variant="secondary"
  [title]="'BUTTONS.NEW_RECORD' | translate"
  (closed)="closeDialog()">

  <div class="record-modal">

    <!-- ── Onglets : saisie manuelle / import de fichiers ──────────────────── -->
    <div class="record-modal__tabs">
      @for (tab of tabs; track tab.key) {
        <app-button
          class="record-modal__tab"
          [variant]="activeTab() === tab.key ? 'primary' : 'secondary'"
          size="xsmall"
          color="mint"
          [addIconLeft]="true"
          [label]="tab.label | translate"
          (clicked)="selectTab(tab.key)">
          <img slot="icon-left" [src]="tab.icon" alt="" />
        </app-button>
      }
    </div>

    <!-- ── Saisie manuelle ────────────────────────────────────────────────── -->
    @if (activeTab() === 'manual') {
      <form class="record-modal__form" [formGroup]="manualForm" (ngSubmit)="submitManualRecord()">

        <div class="field">
          <div class="field__label">
            {{ 'VIBRATION.CONTROL_POINT' | translate }}<span class="field__required">*</span>
          </div>
          <app-select
            [options]="controlPointOptions()"
            size="large"
            formControlName="controlPointId"
            [placeholder]="'VIBRATION.SELECT_CONTROL_POINT' | translate">
          </app-select>
          @if (isFieldInvalid('controlPointId')) {
            <div class="field__error">{{ 'FORM.FIELD_REQUIRED' | translate }}</div>
          }
        </div>

        <div class="field">
          <div class="field__label">
            {{ 'VIBRATION.DISTANCE' | translate }}<span class="field__required">*</span>
          </div>
          <app-input type="number" formControlName="distance" placeholder="e.g. 100"></app-input>
          @if (isFieldInvalid('distance')) {
            <div class="field__error">{{ 'FORM.REQUIRED_POSITIVE_NUMBER' | translate }}</div>
          }
        </div>

        <div class="field">
          <div class="field__label">
            {{ 'VIBRATION.OVERPRESSURE' | translate }}<span class="field__required">*</span>
          </div>
          <app-input type="number" formControlName="overpressure" placeholder="e.g. 1.5"></app-input>
          @if (isFieldInvalid('overpressure')) {
            <div class="field__error">{{ 'FORM.REQUIRED_POSITIVE_NUMBER' | translate }}</div>
          }
        </div>

        <div class="field">
          <div class="field__label">
            {{ 'VIBRATION.PIC' | translate }}<span class="field__required">*</span>
          </div>
          <app-input type="number" formControlName="pic" placeholder="e.g. 2.3"></app-input>
          @if (isFieldInvalid('pic')) {
            <div class="field__error">{{ 'FORM.REQUIRED_POSITIVE_NUMBER' | translate }}</div>
          }
        </div>

      </form>
    }

    <!-- ── Import de fichiers ─────────────────────────────────────────────── -->
    @if (activeTab() === 'upload') {

      @if (rows().length > 0) {
        <app-scrollable class="record-modal__list">
          <app-data-table class="record-table"
            [data]="rows()"
            [columns]="tableColumns"
            rowKey="id"
            sortAscIcon="assets/icon/new_icon/arrow_full_down.svg"
            sortDescIcon="assets/icon/new_icon/arrow_full_up.svg"
            sortIconFilter="brightness(0)">

            <ng-template tableCell="fileName" let-row>
              <div class="record-line">
                <img src="assets/icon/report.svg" alt="" />
                <div class="record-table__stack">
                  <span class="record-table__filename">{{ row.fileName || '-' }}</span>
                  @if (row.sizeLabel) {
                    <span class="record-table__muted">{{ row.sizeLabel }}</span>
                  }
                </div>
              </div>
            </ng-template>

            <ng-template tableCell="timestampMs" let-row>
              <div class="record-table__stack">
                <div>{{ row.dateLabel }}</div>
                <div>{{ row.timeLabel }}</div>
              </div>
            </ng-template>

            <ng-template tableCell="notes" let-row>
              <span>{{ row.notes || '-' }}</span>
            </ng-template>

            <ng-template tableCell="maxPpv" let-row>
              @if (row.channelMaxes.length > 0) {
                <div class="channel-maxes">
                  @for (channel of row.channelMaxes; track channel.label) {
                    <div class="channel-maxes__item">
                      <span class="record-table__muted">{{ channel.label }}</span>
                      <span>{{ channel.value | number: '1.2-2' }}</span>
                    </div>
                  }
                </div>
              } @else {
                <span class="record-table__muted">-</span>
              }
            </ng-template>

            <ng-template tableCell="deviceLabel" let-row>
              <div class="record-line">
                <img src="assets/icon/device.svg" alt="" />
                <span>{{ row.deviceLabel || '-' }}</span>
              </div>
            </ng-template>

            <!-- Retrait de l'enregistrement de la sélection -->
            <ng-template tableCell="remove" let-row>
              <app-button variant="tertiary" size="xsmall" [addLabel]="false" [addIconLeft]="true" (clicked)="removeRecord(row)">
                <img slot="icon-left" src="assets/icon/close.svg" alt="" />
              </app-button>
            </ng-template>

            <!-- Deuxième ligne de la carte : un mini-graphe par canal -->
            <ng-template tableCell="sparklines" let-row>
              @if (row.sparklines.length > 0) {
                <div class="record-table__charts">
                  @for (spark of row.sparklines; track spark.label) {
                    <div class="mini-chart">
                      <span class="mini-chart__name">{{ spark.label }}</span>
                      <div class="mini-chart__yaxis">
                        <span>{{ spark.max | number: '1.1-1' }}</span>
                        <span>{{ spark.min | number: '1.1-1' }}</span>
                      </div>
                      <div class="mini-chart__body">
                        <svg viewBox="0 0 120 40" preserveAspectRatio="none" class="mini-chart__svg">
                          <polyline [attr.points]="spark.points" fill="none" stroke="var(--c-amarante, #6c1d45)" stroke-width="1.2"></polyline>
                        </svg>
                        <div class="mini-chart__ticks">
                          @for (tick of spark.ticks; track $index) {
                            <span>{{ tick }}</span>
                          }
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </ng-template>

          </app-data-table>
        </app-scrollable>
      }

      <!-- Progression de l'envoi -->
      @if (uploadProgress() !== null) {
        <div class="record-modal__progress">
          <div class="record-modal__progress-bar" [style.width.%]="uploadProgress()">{{ uploadProgress() }}%</div>
        </div>
      }

      <!-- Zone de dépôt -->
      <div class="dropzone" (click)="openFilePicker()" (drop)="onFileDrop($event)" (dragover)="onDragOver($event)">
        <input type="file" class="dropzone__input" multiple accept=".sis,.csv" (change)="onFileInputChange($event)" #fileInput />
        <app-button
          variant="tertiary"
          size="small"
          color="mint"
          [label]="'MESSAGE_INFO.UPLOAD_RECORD' | translate"
          (clicked)="openFilePicker($event)">
        </app-button>
        <p class="dropzone__hint">{{ 'MESSAGE_INFO.ACCEPTED_FILE_FORMATS' | translate }}: .sis, .csv (Up to 5Mo)</p>
      </div>
    }

    @if (errorMessage() !== '') {
      <div class="record-modal__error">
        <img src="assets/icon/Polygon_danger.svg" alt="" />
        <span>{{ errorMessage() }}</span>
        <app-button variant="tertiary" size="xsmall" [addLabel]="false" [addIconLeft]="true" (clicked)="closeErrorMessage()">
          <img slot="icon-left" src="assets/icon/close.svg" alt="" />
        </app-button>
      </div>
    }

  </div>

  <!-- ── Actions ──────────────────────────────────────────────────────────── -->
  <div slot="footer" class="record-modal__actions">
    <app-button
      variant="secondary"
      size="small"
      color="mint"
      [label]="'BUTTONS.CANCEL' | translate"
      (clicked)="closeDialog()">
    </app-button>

    @if (activeTab() === 'manual') {
      <app-button
        variant="primary"
        size="small"
        color="mint"
        [state]="isManualSubmitting() ? 'disabled' : 'default'"
        [label]="'BUTTONS.CREATE_RECORD' | translate"
        (clicked)="submitManualRecord()">
      </app-button>
    } @else {
      <app-button
        variant="primary"
        size="small"
        color="mint"
        [state]="isUploading() || isSaving() ? 'disabled' : 'default'"
        [label]="'BUTTONS.CONFIRM' | translate"
        (clicked)="confirmUpload()">
      </app-button>
    }
  </div>

</app-popup>
